import { IndustrialProcessSchema, IndustrialProcessType } from "../types";

export const isOutsourcingProcessStep = (processStep: {
  industrialProcess: IndustrialProcessType;
  isOutsourced?: boolean | null;
}) => {
  if (processStep.isOutsourced !== null && processStep.isOutsourced !== undefined) {
    return processStep.isOutsourced;
  }

  return (
    processStep.industrialProcess === IndustrialProcessSchema.enum.OUTSOURCING ||
    (processStep.industrialProcess === IndustrialProcessSchema.enum.TRANSPORT &&
      processStep.isOutsourced)
  );
};
